import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function CTASection() {
  return <section className="py-32 relative z-10 overflow-hidden bg-hubble-card/50" data-id="element-9">
      {/* Background glow for CTA */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-hubble-primary/5 blur-[100px] rounded-full pointer-events-none" data-id="element-10"></div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-12">
          <h2 className="font-heading text-5xl md:text-6xl font-normal tracking-[-1px] text-hubble-text mb-6" data-id="element-13">
            Stop rebuilding the same integrations.
          </h2>
          <p className="font-body text-[18px] text-hubble-body mb-10 max-w-2xl mx-auto leading-[1.6]" data-id="element-14">
            Hubble gives your agents the context they need to navigate
            healthcare.
          </p>
          <Button variant="primary" size="lg" onClick={() => window.open('https://calendly.com/prabha-hubble/30min?month=2026-04', '_blank')} data-id="element-15">
            Book Demo
          </Button>
        </motion.div>
      </div>
    </section>;
}